import React from "react";

interface BrandKitIconProps {
  isActive?: boolean;
  cypress_id?: string;
}

export const BrandKitIcon: React.FC<BrandKitIconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17 21C15.9391 21 14.9217 20.5786 14.1716 19.8284C13.4214 19.0783 13 18.0609 13 17V5C13 4.46957 13.2107 3.96086 13.5858 3.58579C13.9609 3.21071 14.4696 3 15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V17C21 18.0609 20.5786 19.0783 19.8284 19.8284C19.0783 20.5786 18.0609 21 17 21ZM17 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15C3 14.4696 3.21071 13.9609 3.58579 13.5858C3.96086 13.2107 4.46957 13 5 13H7.3M13 7.35L11 5.35C10.6249 4.97506 10.1163 4.76443 9.586 4.76443C9.05567 4.76443 8.54706 4.97506 8.172 5.35L5.344 8.178C4.96906 8.55306 4.75843 9.06167 4.75843 9.592C4.75843 10.1223 4.96906 10.6309 5.344 11.006L14.344 20.006M17 17V17.01"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
